import React from 'react'
import Flow from 'procedures/Flow'
import {get, isEmpty} from 'lodash'

export const makeFlow = function* (employee) {
  if (isEmpty(employee) || isEmpty(employee.office)) {
    return
  }
  const healthInsuranceJoined = get(employee, 'health_insurance.joined')
  const welfarePensionInsuranceJoined = get(employee, 'welfare_pension_insurance.joined')
  const healthInsuranceType = get(employee, 'office.health_insurance_type')
  if (healthInsuranceJoined || welfarePensionInsuranceJoined) {
    if (healthInsuranceType === 'its') {
      yield 'R13'
    } else {
      yield 'R12'
    }
  }
  if (welfarePensionInsuranceJoined && employee.national_type === 'foreigner') {
    yield 'R55'
  }
}

const ChangeNameFlow = ({location, match}) => <Flow {...{makeFlow, location, match}} />

export default ChangeNameFlow
